import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a30f3ce")

_pushScopeId("data-v-1a30f3ce")
const _hoisted_1 = { class: "CourierInformation" }
const _hoisted_2 = {
  key: 0,
  class: "CourierInformation__loading"
}
const _hoisted_3 = {
  key: 1,
  class: "CourierInformation__delivered"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Заказ уже "),
  /*#__PURE__*/_createVNode("u", null, "доставлен")
], -1)
const _hoisted_5 = {
  key: 2,
  class: "CourierInformation__failed"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "Произошла ошибка, обновите страницу", -1)
const _hoisted_7 = {
  key: 3,
  class: "CourierInformation__courier"
}
const _hoisted_8 = { class: "courier__address" }
const _hoisted_9 = { class: "courier__info" }
const _hoisted_10 = { class: "courier__name" }
const _hoisted_11 = { class: "courier__car" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_s_loader)
        ]))
      : (_ctx.isDeliveryCompleted)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4
          ]))
        : (_ctx.isFailed)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : (_ctx.isLoaded && Boolean(_ctx.courier))
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, "По адресу: " + _toDisplayString(_ctx.addressTo), 1),
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, "Курьер: " + _toDisplayString(_ctx.courier.name), 1),
                  _createVNode("span", _hoisted_11, "Транспорт: " + _toDisplayString(_ctx.courier.transport), 1)
                ])
              ]))
            : _createCommentVNode("", true)
  ]))
})